import {MessageStyle, MessageStyleProps} from "./message.style";
import React, {JSX, LazyExoticComponent, ReactElement, ReactNode} from "react";
import IconType from "../../assets/icons";
import {CustomHelper} from "../../helpers";

export interface MessageProps extends Omit<MessageStyleProps, "$status"> {
    $status?: "successful" | "failed" | "default";
}

export const MessageComponent = ({
                                     icon,
                                     title,
                                     iconClassName,
                                     $status = "default",
                                     action,
                                     ...props
                                 }: MessageProps) => {
    return <MessageStyle  {...props} $status={$status}>
        {icon && <div className="icon">{CustomHelper.renderIcon(icon, iconClassName)}
        </div>
        }
        {title &&
            <h4 className={"title"}>
                Complete your kyc verification!
            </h4>}
        <span className={"message"}>
            {props.message}
        </span>
        {action &&
            <div className={"action"}>{action}</div>
        }
    </MessageStyle>
}